import React, { useContext, useState } from "react";
import zohoLogo from "../../images/zoho_logo.png";
import LoadingIcon from "../../images/Loading_icon.gif";
import Swal from "sweetalert2";
import { UrlContext } from "../../contexts/UrlContext";

export default function ZohoButton({ data }) {
  //    const [addToZohoPopup, setAddToZohoPopup] = useState(false)
  const [updateToZohoPopup, setUpdateToZohoPopup] = useState(false);
  const [downloadFromZohoPopup, setDownloadFromZohoPopup] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  //    const [addLoading, setAddLoading] = useState(false)
  const { API_URL } = useContext(UrlContext);
  const updateToZohoHandler = () => {
    console.log(data);
    setUpdateLoading(true);
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    const url = `${API_URL}updateClient-to-zoho`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ client_id: data.clientID }),
    })
      .then((res) => res.json())
      .then((data) => {
        setUpdateToZohoPopup(false);
        setUpdateLoading(false);
        if (data.status === "success") {
          Swal.fire({
            icon: "success",
            title: "Client has been updated to Zoho",
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Something went wrong",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
  };
  const downloadFromZohoHandler = () => {
    console.log(data);
    setDownloadLoading(true);
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    const url = `${API_URL}downloadClient-from-zoho`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ client_id: data.clientID }),
    })
      .then((res) => res.json())
      .then((data) => {
        setDownloadFromZohoPopup(false);
        setDownloadLoading(false);
        if (data.status === "success") {
          Swal.fire({
            icon: "success",
            title: "Client has been updated from Zoho",
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Something went wrong",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
  };

  return (
    <>
      {
        <>
          <button
            className="btn updateToZohoBtn"
            onClick={() => setDownloadFromZohoPopup(true)}
          >
            <i className="fa-solid fa-arrow-down-to-bracket"></i>
            <i className="fa-solid fa-cloud-arrow-down" /> Download from{" "}
            <img
              width="50px"
              src={zohoLogo}
              style={{ marginBottom: "6px" }}
              alt=""
            />
          </button>
          <button
            className="btn updateToZohoBtn"
            onClick={() => setUpdateToZohoPopup(true)}
          >
            <i className="fa-solid fa-arrow-up-from-bracket" /> Update to{" "}
            <img
              width="50px"
              src={zohoLogo}
              style={{ marginBottom: "6px" }}
              alt=""
            />
          </button>
        </>
      }

      {updateToZohoPopup && (
        <div className="updateToZoho-popup-wrapper">
          <div className="tab-pane fade show updateToZoho-div">
            {!updateLoading ? (
              <>
                <div>
                  <center>
                    <img className="image" src={zohoLogo} alt="" />
                    <p>
                      Do you want to update this profile to{" "}
                      <strong>Zoho?</strong>
                    </p>
                    <br />
                  </center>
                </div>
                <div>
                  <center>
                    <button
                      className="btn btn-light"
                      onClick={() => setUpdateToZohoPopup(false)}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      onClick={updateToZohoHandler}
                      className="btn base-btn"
                      style={{ marginLeft: "6px" }}
                    >
                      Continue
                    </button>
                  </center>
                </div>
              </>
            ) : (
              <center>
                <p style={{ fontSize: "18px" }}>Updating data...</p>
                <br />
                <img
                  src={LoadingIcon}
                  alt=""
                  style={{ width: "50px", marginRight: "5px" }}
                />
              </center>
            )}
          </div>
        </div>
      )}

      {downloadFromZohoPopup && (
        <div className="downloadFromZoho-popup-wrapper">
          <div className="tab-pane fade show downloadFromZoho-div">
            {!downloadLoading ? (
              <>
                <div>
                  <center>
                    <img className="image" src={zohoLogo} alt="" />
                    <p>
                      Do you want to download this profile from{" "}
                      <strong>Zoho?</strong>
                    </p>
                    <br />
                  </center>
                </div>
                <div>
                  <center>
                    <button
                      className="btn btn-light"
                      onClick={() => setDownloadFromZohoPopup(false)}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      onClick={downloadFromZohoHandler}
                      className="btn base-btn"
                      style={{ marginLeft: "6px" }}
                    >
                      Continue
                    </button>
                  </center>
                </div>
              </>
            ) : (
              <center>
                <p style={{ fontSize: "18px" }}>Downloading data...</p>
                <br />
                <img
                  src={LoadingIcon}
                  alt=""
                  style={{ width: "50px", marginRight: "5px" }}
                />
              </center>
            )}
          </div>
        </div>
      )}
    </>
  );
}
